<div class="tw-px-2 tw-rounded-full" [ngStyle]="{'background-color': colorCode}">
  <span [ngStyle]="{'color': invertedColorCode}">{{colorName | titlecase}}</span>
</div>